import React, { Component } from "react";
import FormField from "../home/form.jsx";
import axios from "axios";
import MemeList from "../home/MemeList.jsx";
import { Pagination, Icon, Header, Button } from "semantic-ui-react";

// importing constants
const { API } = require("../../global/constants");

// main App class
export default class App extends Component {
    state = {
        memes: [],
        activePage: 0,
    };
    getAllMemes = async () => {
        const URI = `${API}api/meme/all`;
        await axios
            .get(URI)
            .then((res) => {
                this.setState({ memes: res.data });
            })
            .catch((e) => {
                alert("API error");
                console.log("ERROR at getAllMemes", e);
            });
    };

    // responsible to change backgroundColor and fetch memes on component mounting
    async componentDidMount() {
        await this.getAllMemes();
    }

    // helper function for pagination
    handlePageChange = (e, pageInfo) => {
        console.log(pageInfo);
        this.setState({ activePage: pageInfo.activePage - 1 });
    };

    logoutHandler = (e) => {
        localStorage.removeItem("authToken");
        this.props.history.push("/login");
    };

    createMeme = async (caption, url) => {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("unauthorized");
        }
        const headers = {
            authorization: "Bearer " + authToken,
        };
        const meme = {
            caption: caption,
            url: url,
        };
        await axios
            .post(`${API}api/meme/create`, meme, { headers: headers })
            .then((res) => {
                console.log("[INFO] created");
                const updatedMemes = [res.data.meme, ...this.state.memes];
                this.setState({ memes: updatedMemes });
            })
            .catch((e) => {
                console.log("[ERROR] at createMeme", e);
            });
    };

    deleteMeme = async (id) => {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("unauthorized");
        }
        const headers = {
            Authorization: "Bearer " + authToken,
        };
        await axios
            .delete(`${API}api/meme/delete`, {
                data: { id: id },
                headers: headers,
            })
            .then((res) => {
                console.log("[INFO] deleted");
                const updatedMemes = this.state.memes.filter(
                    (meme) => meme._id !== id
                );
                this.setState({ memes: updatedMemes });
            })
            .catch((e) => {
                this.setState({ dbErr: "1" });
                console.log("ERROR at deleteMeme", e);
            });
    };

    render() {
        let PER_PAGE = 5;
        let totalPages = this.state.memes.length / PER_PAGE;
        let start = this.state.activePage * PER_PAGE;
        let end = start + PER_PAGE;
        return (
            <div>
                <div className="topbar">
                    <div></div>
                    <Header className="xmeme" as="h1">
                        XMeme
                    </Header>
                    <Button
                        inverted
                        color="red"
                        className="logout"
                        onClick={this.logoutHandler}
                    >
                        Logout
                    </Button>
                </div>
                <br />
                <FormField createMeme={this.createMeme} />
                <br />
                <br />
                <br />
                <MemeList
                    memes={this.state.memes.slice(start, end)}
                    deleteMeme={this.deleteMeme}
                />
                <br />
                <br />
                <br />
                <Pagination
                    activepage={this.state.activePage}
                    onPageChange={this.handlePageChange}
                    ellipsisItem={{
                        content: <Icon name="ellipsis horizontal" />,
                        icon: true,
                    }}
                    firstItem={{
                        content: <Icon name="angle double left" />,
                        icon: true,
                    }}
                    lastItem={{
                        content: <Icon name="angle double right" />,
                        icon: true,
                    }}
                    prevItem={{
                        content: <Icon name="angle left" />,
                        icon: true,
                    }}
                    nextItem={{
                        content: <Icon name="angle right" />,
                        icon: true,
                    }}
                    totalPages={totalPages}
                    className="paginator"
                />
            </div>
        );
    }
}
